/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation EntityDelete($entityIds: [ID!]) {
    EntityDelete(entityIds: $entityIds) {
        message
        status
    }
} 
`

